document.getElementById('expand-button').addEventListener('click', function() {
    const content = document.getElementById('expand-content');
    const isExpanded = content.classList.contains('expanded');

    if (isExpanded) {
        content.classList.remove('expanded');
        this.classList.remove('active');
    } else {
        content.classList.add('expanded');
        this.classList.add('active');
    }
});